import appLocaleData from 'react-intl/locale-data/en';
import enMessages from '../locales/en_US.json';

const enLang = {
  messages: { ...enMessages },
  locale: 'en-US',
  data: appLocaleData,
};
export default enLang;



// WEBPACK FOOTER //
// ./lngProvider/entries/en_US.js